import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  IconButton,
  Popover,
} from '@mui/material';
// mocks_
import account from '../../../_mock/account';
import { tokenService } from 'src/services';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
  },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleClose1 = () => {
    localStorage.removeItem('user');
    //localStorage.removeItem('mallID');
    setOpen(null);
    navigate('/login');
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          // width: 55,
          // height: 55,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: 48,
              height: 48,
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <div style={imagesStyle}>
          {tokenService.getUser()?.name[0].toUpperCase() +
            tokenService.getUser()?.lastname[0].toUpperCase()}
        </div>{' '}
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {tokenService.getUser()?.name} {tokenService.getUser()?.lastname}
          </Typography>
          {/* <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {account.email}
          </Typography> */}
        </Box>

        {/* <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack> */}

        <Divider sx={{ borderStyle: 'dashed' }} />
        <Link
          to="/dashboard/profile"
          style={{ textDecoration: 'none', color: 'black' }}
        >
          <MenuItem sx={{ m: 1 }}>Şifre Yenileme</MenuItem>
        </Link>
        <MenuItem onClick={handleClose1} sx={{ m: 1 }}>
          Çıkış Yap
        </MenuItem>
      </Popover>
    </>
  );
}

const imagesStyle = {
  width: '45px',
  height: '45px',
  borderRadius: '50%',
  background: '#172955',
  fontSize: '18px',
  color: '#fff',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
